import FJFaceSwapLeft from './FJFaceSwapLeft';
import { useDispatch, useSelector } from 'react-redux';
import useLocalStore from '../../../hooks/useLocalStore';
import { useCallback } from 'react';
import FJActionFaceSwap from '../../../redux/action/FJActionFaceSwap';
import FJActionEditPage from '../../../redux/action/FJActionEditPage.js';
import {
    CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES,
    UPLOAD_FILE_TYPE_IMAGE_EXTENDER,
    UPLOAD_FILE_TYPE_NO_GIF,
    UPLOAD_IMAGE_FILE_TYPE_NO_NEED_TRANSCODE,
} from '../../../config/dataConfig/FJGenerateData.js';

const FJFaceSwapLeftContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();

    const originUploadImageInfo = useSelector(state => state.faceSwap.originUploadImageInfo);
    const targetUploadImageInfo = useSelector(state => state.faceSwap.targetUploadImageInfo);
    const taskStatus = useSelector(state => state.common.taskStatus);
    const creditNumber = useSelector(state => state.common.creditNumber);
    const freeNumCreation = useSelector(state => state.common.freeNumCreation);
    const isProjectLoading = useSelector(state => state.common.isProjectLoading);

    const originCurLoadName = useSelector(state => state.faceSwap.originCurLoadName);
    const targetCurLoadName = useSelector(state => state.faceSwap.targetCurLoadName);

    const _onGenerate = useCallback(() => {
        dispatch(FJActionFaceSwap.generateAction());
    }, [dispatch]);

    const _onUploadImage = useCallback(
        file => {
            dispatch(FJActionFaceSwap.uploadOriginImageAction(file));
        },
        [dispatch],
    );

    const _onUploadTargetImage = useCallback(
        file => {
            dispatch(FJActionFaceSwap.uploadTargetImageAction(file));
        },
        [dispatch],
    );

    const _onOriginTryThose = useCallback(
        item => {
            dispatch(FJActionFaceSwap.uploadOriginTryThoseImageAction(item));
        },
        [dispatch],
    );

    const _onTargetTryThose = useCallback(
        item => {
            dispatch(FJActionFaceSwap.uploadTargetTryThoseImageAction(item));
        },
        [dispatch],
    );

    const _openMediaLibrary = (isOriginalImage = false) => {
        dispatch(
            FJActionEditPage.openMediaLibraryAction({
                uploadConfig: {
                    isMultiple: false,
                    maxMediaNum: 1,
                    selectedMediaIds: [],
                    acceptTypeWithTranscode: UPLOAD_FILE_TYPE_NO_GIF + CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES,
                    acceptTypeNoTranscode: UPLOAD_IMAGE_FILE_TYPE_NO_NEED_TRANSCODE,
                    suffixTranscode: CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES,
                    // 媒体库的过滤规则
                    mediaFilterFunc: item => {
                        const mediaTypes = ['IMAGE'];
                        return mediaTypes.includes(item.type);
                    },
                    // 上传文件之后返回的数据
                    callbackOptions: {
                        isOriginalImage: isOriginalImage,
                    },
                },
            }),
        );
    };

    return (
        <FJFaceSwapLeft
            creditNumber={creditNumber}
            taskStatus={taskStatus}
            onGenerate={_onGenerate}
            freeNumCreation={freeNumCreation}
            uploadImageInfo={originUploadImageInfo}
            targetUploadImageInfo={targetUploadImageInfo}
            onUploadImage={_onUploadImage}
            openMediaLibrary={_openMediaLibrary}
            onUploadTargetImage={_onUploadTargetImage}
            isProjectLoading={isProjectLoading}
            onOriginTryThose={_onOriginTryThose}
            onTargetTryThose={_onTargetTryThose}
            originCurLoadName={originCurLoadName}
            targetCurLoadName={targetCurLoadName}
        />
    );
};
export default FJFaceSwapLeftContainer;
